// src/context/LanguageContext.jsx
// Urus bahasa pilihan user.
// - Sebelum login: ikut localStorage (instant, ingat dalam browser)
// - Selepas login: ikut akaun (Firestore) — sama merentas peranti
// - Bila tukar: simpan ke localStorage + Firestore

import { createContext, useContext, useEffect, useState } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "./AuthContext";
import { TRANSLATIONS } from "../data/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const { user, userDoc } = useAuth();

  // Mula dengan pilihan tersimpan dalam browser (fallback "en")
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("promptix_lang");
    return saved && TRANSLATIONS[saved] ? saved : "en";
  });

  // Bila userDoc dimuatkan & ada bahasa tersimpan dalam akaun → guna
  useEffect(() => {
    if (userDoc?.language && TRANSLATIONS[userDoc.language]) {
      setLang(userDoc.language);
      localStorage.setItem("promptix_lang", userDoc.language);
    }
  }, [userDoc]);

  // Tukar bahasa
  const changeLang = async (newLang) => {
    if (!TRANSLATIONS[newLang]) return;
    setLang(newLang);
    localStorage.setItem("promptix_lang", newLang);

    // Simpan ke akaun kalau dah login
    if (user) {
      try {
        await updateDoc(doc(db, "users", user.uid), { language: newLang });
      } catch (e) {
        console.error("Gagal simpan bahasa ke akaun:", e);
      }
    }
  };

  // Helper terjemah — fallback ke English, kemudian ke key itu sendiri
  const t = (key) =>
    TRANSLATIONS[lang]?.[key] ?? TRANSLATIONS.en[key] ?? key;

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}